import React from "react";
import Modal, {
  ModalTransition,
  ModalBody,
} from "@atlaskit/modal-dialog";
import { useDispatch, useSelector } from "react-redux";
import { showWizard } from "../../redux/actions/wizardActions";
import WizardMainFrame from "../WizardMainFrame";
import WizardModalFooter from "./WizardModalFooter";
import WizardModalHeader from "./WizardModalHeader";
import { useEscapeShortcut } from "../../common/utils/keybindings";
const StartWizardModal = () => {
  const isWizardOpen = useSelector((state) => state.wizard.isWizardOpen);
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(showWizard(false));
  };

  useEscapeShortcut(closeModal)

  return (
    <div>
      <ModalTransition>
        {isWizardOpen && (
          <Modal
            width="x-large"
            height="x-large"
            shouldCloseOnEscapePress={false}
            shouldCloseOnOverlayClick={false}
          >
            <WizardModalHeader />
            <ModalBody>
              <WizardMainFrame />
            </ModalBody>
            <WizardModalFooter />
          </Modal>
        )}
      </ModalTransition>
    </div>
  );
};
export default StartWizardModal;
